import React, { Fragment } from 'react';
import { MyAccountMenuItem } from './items/MyAccountMenuItem';

export const DefaultMenu = () => (
    <Fragment>
        <MyAccountMenuItem />
    </Fragment>
);
